import styled from 'styled-components';
import React from 'react';
import sortBy from 'lodash/sortBy';

import { formatHandicap, removePipes, withRootTestId } from '@williamhill/rosi-ui-shared/src/lib';
import { Leg, struckThroughStyles } from './legs-component';
import { Text } from '@williamhill/rosi-ui-shared/src/components/typography/Typography';
import { ResultIcon } from './result-icon';

export default function SGPLegsComponent({ legs }: { legs: Leg[] }) {
  return (
    <>
      <SGPLegsList weight="medium" as="ul">
        {sortBy(legs, ({ eventStartTime }) => new Date(eventStartTime).getTime()).map(
          ({ id, market, selection, result, marketLine }) => {
            const withTestId = withRootTestId(`bet-tracker-bets-ticket-leg-${id}`);
            const selectionName = removePipes(selection.name);
            const isInjuryProtected = result?.type === 'injury_protection';
            const isStruckThrough = result?.type === 'void' || isInjuryProtected;

            return (
              <SGPLegItem data-testid={withTestId()} key={id}>
                <ResultIcon resultType={result?.type} />
                <section>
                  <main>
                    <SelectionNameContainer
                      weight="bold"
                      data-testid={withTestId('name')}
                      isStruckThrough={isStruckThrough}>
                      {selectionName}
                      {marketLine && ` ${formatHandicap(marketLine, selectionName, false)}`}
                    </SelectionNameContainer>
                    <MarketNameContainer data-testid={withTestId('market')} isStruckThrough={isStruckThrough}>
                      {removePipes(market.name)}
                    </MarketNameContainer>
                  </main>
                </section>
              </SGPLegItem>
            );
          }
        )}
      </SGPLegsList>
    </>
  );
}

const SGPLegsList = styled(Text)`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  list-style-type: none;
  margin: 0 0 0 -2.2rem;
  padding: 0.8rem 0;
`;

const SGPLegItem = styled.li`
  align-items: center;
  display: flex;
  gap: 1rem;
  position: relative;

  &:not(:last-child) {
    ::after {
      border-left: 0.1rem solid ${({ theme }) => theme.colors.modals.neutral};
      /* prettier-ignore */
      content: "";
      display: block;
      height: calc(100% + 1.3rem);
      left: 0.6rem;
      position: absolute;
      top: 1rem;
      z-index: 0;
    }
  }
`;

const SelectionNameContainer = styled(Text)<{ isStruckThrough?: boolean }>`
  flex-grow: 1;
  ${({ isStruckThrough }) => isStruckThrough && struckThroughStyles}
`;

const MarketNameContainer = styled.span<{ isStruckThrough?: boolean }>`
  color: ${({ theme }) => theme.colors.brand.quaternary};
  margin: 0 0.5rem;
  ${({ isStruckThrough }) => isStruckThrough && struckThroughStyles}
`;
